import type { ComponentType, SVGProps } from 'react';
import {
  NavDashboardIcon,
  PackageDeliveryIcon,
  LocationArrowIcon,
  BarChartIcon,
  MoneyIcon,
} from '@noor/ui';

/**
 * The Delivery (Доставка) nav sections — one definition per section, shared by
 * both nav surfaces (desktop segmented top-nav + mobile bottom bar). The shell
 * maps over this ordered list and derives the active entry from the current
 * path. Mirrors the Eats sub-app's `config/nav.ts`.
 */
export interface DeliveryNavItem {
  /** Absolute route path this segment links to. */
  path: string;
  /** i18n key under the `delivery` namespace (`nav.<key>`). */
  labelKey: string;
  /** Bottom-nav (mobile) glyph — inherits `currentColor` from tab state. */
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}

/**
 * Desktop top-nav order (the `SegmentedNav`):
 * Dashboard · Delivery · Branches · Reports · Tariffs.
 */
export const DELIVERY_NAV: readonly DeliveryNavItem[] = [
  { path: '/delivery', labelKey: 'nav.dashboard', icon: NavDashboardIcon },
  { path: '/delivery/orders', labelKey: 'nav.delivery', icon: PackageDeliveryIcon },
  { path: '/delivery/branches', labelKey: 'nav.branches', icon: LocationArrowIcon },
  { path: '/delivery/reports', labelKey: 'nav.reports', icon: BarChartIcon },
  { path: '/delivery/tariffs', labelKey: 'nav.tariffs', icon: MoneyIcon },
] as const;
